import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

export default function Regiomaten() {
  const { user } = useAuth();
  const istAdmin = !!user?.isAdmin;

  const [regiomaten, setRegiomaten] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showForm,   setShowForm]   = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [fehler,     setFehler]     = useState(null);
  const [form,       setForm]       = useState({ titel: "", beschreibung: "", adresse: "", bildBase64: null, bildTyp: null });
  const [editId,     setEditId]     = useState(null);
  const [editForm,   setEditForm]   = useState({});
  const [editSaving, setEditSaving] = useState(false);
  const [editFehler, setEditFehler] = useState(null);
  const fileRef    = useRef();
  const editFileRef = useRef();

  useEffect(() => {
    api.regiomaten.getAll()
      .then(setRegiomaten)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleBild = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const base64 = ev.target.result; // data:image/...;base64,...
      const typ    = file.type;
      setForm(f => ({ ...f, bildBase64: base64, bildTyp: typ }));
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.titel.trim()) return;
    setFehler(null);
    setSaving(true);
    try {
      const neu = await api.regiomaten.create({
        titel:        form.titel,
        beschreibung: form.beschreibung || null,
        adresse:      form.adresse      || null,
        bildBase64:   form.bildBase64   || null,
        bildTyp:      form.bildTyp      || null,
      });
      setRegiomaten(prev => [...prev, { ...form, regiomatId: neu.regiomatId, erstelltAm: new Date().toISOString().slice(0,10) }]);
      setForm({ titel: "", beschreibung: "", adresse: "", bildBase64: null, bildTyp: null });
      setShowForm(false);
      if (fileRef.current) fileRef.current.value = "";
    } catch (err) {
      setFehler(err.message || "Fehler beim Speichern.");
    }
    setSaving(false);
  };

  const startEdit = (r) => {
    setEditId(r.regiomatId);
    setEditForm({ titel: r.titel, beschreibung: r.beschreibung || "", adresse: r.adresse || "", bildBase64: r.bildBase64 || null, bildTyp: r.bildTyp || null });
    setEditFehler(null);
  };

  const handleEditBild = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setEditForm(f => ({ ...f, bildBase64: ev.target.result, bildTyp: file.type }));
    reader.readAsDataURL(file);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editForm.titel.trim()) return;
    setEditFehler(null);
    setEditSaving(true);
    try {
      await api.regiomaten.update(editId, {
        titel:        editForm.titel,
        beschreibung: editForm.beschreibung || null,
        adresse:      editForm.adresse      || null,
        bildBase64:   editForm.bildBase64   || null,
        bildTyp:      editForm.bildTyp      || null,
      });
      setRegiomaten(prev => prev.map(r => r.regiomatId === editId ? { ...r, ...editForm } : r));
      setEditId(null);
    } catch (err) {
      setEditFehler(err.message || "Fehler beim Speichern.");
    }
    setEditSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Regiomat wirklich löschen?")) return;
    await api.regiomaten.delete(id);
    setRegiomaten(prev => prev.filter(r => r.regiomatId !== id));
  };

  return (
    <div className="container" style={{ maxWidth: 860 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
        <h2 className="section-title" style={{ margin: 0 }}>Regiomaten</h2>
        {istAdmin && (
          <button onClick={() => setShowForm(s => !s)} style={{
            padding: "0.45rem 1.1rem", borderRadius: "8px", border: "none",
            background: showForm ? "#e0e0e0" : "#1b5e20", color: showForm ? "#444" : "white",
            fontWeight: 700, cursor: "pointer", fontSize: "0.9rem",
          }}>
            {showForm ? "✕ Abbrechen" : "+ Regiomat hinzufügen"}
          </button>
        )}
      </div>

      {/* Admin-Formular */}
      {istAdmin && showForm && (
        <form onSubmit={handleSubmit} className="card" style={{ marginTop: "1.25rem", border: "1.5px solid #a5d6a7", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          <h3 style={{ color: "#1b5e20", margin: 0 }}>Neuer Regiomat</h3>
           {fehler && <div style={{ background: "#ffebee", border: "1px solid #ef9a9a", borderRadius: "8px", padding: "0.6rem 1rem", color: "#c62828", fontSize: "0.9rem" }}>{fehler}</div>}

          <input required placeholder="Titel (z.B. Unser Regiomat in Groß Sisbeck)"
            value={form.titel} onChange={e => setForm(f => ({ ...f, titel: e.target.value }))}
            style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.95rem" }} />

          <textarea placeholder="Beschreibung (optional)" rows={4}
            value={form.beschreibung} onChange={e => setForm(f => ({ ...f, beschreibung: e.target.value }))}
            style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.9rem", resize: "vertical" }} />

          <input placeholder="Adresse (z.B. Dorfstraße 5, 38473 Groß Sisbeck)"
            value={form.adresse} onChange={e => setForm(f => ({ ...f, adresse: e.target.value }))}
            style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.9rem" }} />

          <div>
            <label style={{ fontSize: "0.85rem", color: "#666", display: "block", marginBottom: "0.3rem" }}>Foto (optional)</label>
            <input type="file" accept="image/*" ref={fileRef} onChange={handleBild}
              style={{ fontSize: "0.9rem" }} />
            {form.bildBase64 && (
              <img src={form.bildBase64} alt="Vorschau"
                style={{ marginTop: "0.5rem", maxHeight: 160, borderRadius: "8px", objectFit: "cover", display: "block" }} />
            )}
          </div>

          <button type="submit" disabled={saving} style={{
            padding: "0.5rem 1.5rem", borderRadius: "8px", border: "none",
            background: "#1b5e20", color: "white", fontWeight: 700, cursor: "pointer", alignSelf: "flex-start",
          }}>
            {saving ? "Speichern..." : "💾 Speichern"}
          </button>
        </form>
      )}

      {loading && (
        <div style={{ textAlign: "center", color: "#888", padding: "3rem" }}>Wird geladen...</div>
      )}

      {!loading && regiomaten.length === 0 && (
        <div className="card" style={{ textAlign: "center", color: "#888", padding: "2rem", marginTop: "1.5rem" }}>
          Noch keine Regiomaten eingetragen.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "2.5rem", marginTop: "1.5rem" }}>
        {regiomaten.map(r => (
          <div key={r.regiomatId} className="card" style={{ padding: 0, overflow: "hidden", border: "1.5px solid #c8e6c9" }}>

            {editId === r.regiomatId ? (
              /* ── Editierformular ── */
              <form onSubmit={handleEditSubmit} style={{ padding: "1.5rem", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                <h3 style={{ color: "#1b5e20", margin: 0 }}>✏️ Regiomat bearbeiten</h3>
                {editFehler && <div style={{ background: "#ffebee", border: "1px solid #ef9a9a", borderRadius: "8px", padding: "0.6rem 1rem", color: "#c62828", fontSize: "0.9rem" }}>{editFehler}</div>}

                <input required value={editForm.titel}
                  onChange={e => setEditForm(f => ({ ...f, titel: e.target.value }))}
                  placeholder="Titel"
                  style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.95rem" }} />

                <textarea rows={4} value={editForm.beschreibung}
                  onChange={e => setEditForm(f => ({ ...f, beschreibung: e.target.value }))}
                  placeholder="Beschreibung (optional)"
                  style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.9rem", resize: "vertical" }} />

                <input value={editForm.adresse}
                  onChange={e => setEditForm(f => ({ ...f, adresse: e.target.value }))}
                  placeholder="Adresse (optional)"
                  style={{ padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.9rem" }} />

                <div>
                  <label style={{ fontSize: "0.85rem", color: "#666", display: "block", marginBottom: "0.3rem" }}>Neues Foto (optional – leer lassen um bisheriges zu behalten)</label>
                  <input type="file" accept="image/*" ref={editFileRef} onChange={handleEditBild} style={{ fontSize: "0.9rem" }} />
                  {editForm.bildBase64 && (
                    <img src={editForm.bildBase64} alt="Vorschau"
                      style={{ marginTop: "0.5rem", maxHeight: 160, borderRadius: "8px", objectFit: "cover", display: "block" }} />
                  )}
                </div>

                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <button type="submit" disabled={editSaving} style={{
                    padding: "0.5rem 1.25rem", borderRadius: "8px", border: "none",
                    background: "#1b5e20", color: "white", fontWeight: 700, cursor: "pointer",
                  }}>{editSaving ? "Speichern..." : "💾 Speichern"}</button>
                  <button type="button" onClick={() => setEditId(null)} style={{
                    padding: "0.5rem 1.25rem", borderRadius: "8px", border: "1.5px solid #ccc",
                    background: "white", color: "#555", cursor: "pointer",
                  }}>Abbrechen</button>
                </div>
              </form>
            ) : (
              /* ── Normale Ansicht ── */
              <>
                {r.bildBase64 && (
                  <img src={r.bildBase64} alt={r.titel}
                    style={{ width: "100%", maxHeight: 340, objectFit: "cover", display: "block" }} />
                )}
                <div style={{ padding: "1.5rem" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem" }}>
                    <h3 style={{ color: "#1b5e20", margin: 0, fontSize: "1.3rem", textTransform: "uppercase", letterSpacing: "0.03em" }}>
                      {r.titel}
                    </h3>
                    {istAdmin && (
                      <div style={{ display: "flex", gap: "0.5rem", flexShrink: 0 }}>
                        <button onClick={() => startEdit(r)} style={{
                          background: "none", border: "1px solid #81c784", borderRadius: "6px",
                          color: "#2e7d32", cursor: "pointer", padding: "0.25rem 0.6rem", fontSize: "0.8rem",
                        }}>✏️ Bearbeiten</button>
                        <button onClick={() => handleDelete(r.regiomatId)} style={{
                          background: "none", border: "1px solid #e57373", borderRadius: "6px",
                          color: "#c62828", cursor: "pointer", padding: "0.25rem 0.6rem", fontSize: "0.8rem",
                        }}>🗑 Löschen</button>
                      </div>
                    )}
                  </div>
                  {r.beschreibung && (
                    <p style={{ color: "#444", marginTop: "0.85rem", lineHeight: 1.8, whiteSpace: "pre-wrap", fontSize: "0.97rem" }}>
                      {r.beschreibung}
                    </p>
                  )}
                  {r.adresse && (
                    <p style={{ marginTop: "0.75rem", color: "#777", fontSize: "0.85rem", display: "flex", alignItems: "center", gap: "0.35rem" }}>
                      📍 {r.adresse}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
